import React from 'react'
import { Icon } from '../../../atoms'

interface Item {
  icon: string
  title: string
  desc: string
}

interface WhyChooseUsModuleProps {
  name: string
  jsonBody: {
    reasons: Item[]
  }
  showHeader: boolean
}

const WhyChooseUS = ({ jsonBody, name, showHeader }: WhyChooseUsModuleProps) => {
  try {
    return (
      <div className='why-choose-us' id={name}>
        {showHeader && <h2 className='why-choose-us__heading'>Why use money.co.uk?</h2>}
        <div className='why-choose-us__container'>
          {jsonBody.reasons.map((ele, i) => (
            <div className='why-choose-us__container__box' key={i}>
              <Icon glyph={ele.icon} size={24} desktopSize={48} color='#34454E' />
              <span className='why-choose-us__title'>{ele.title}</span>
              <div
                className={
                  i === 2
                    ? 'why-choose-us__container__divider-hide'
                    : 'why-choose-us__container__divider'
                }
              />
              <span className='why-choose-us__desc'>{ele.desc}</span>
            </div>
          ))}
        </div>
      </div>
    )
  } catch (error) {
    return <></>
  }
}

export default WhyChooseUS
